import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { PersonalProfile } from 'merchant-components'

export const Route = createFileRoute('/_merchant/_portal/profile')({
  component: PersonalProfile,
})
